import API from "./API";

export default class Invoices extends API
{
    static async create(params) {
        return this.post("api/admin/invoices", params);
    }
    
}